document.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('header');
    let ticking = false;
    function onScroll() {
        if (!ticking) {
            window.requestAnimationFrame(() => {                
                const headerHeight = header.offsetHeight + 100;
                const trigger = headerHeight;
                document.body.classList.toggle('sticky', window.scrollY > trigger);
                header.classList.toggle('sticky', window.scrollY > trigger);
                ticking = false;
            });
            ticking = true;
        } 
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    const menuBtn = document.querySelector('.btn-menu');
    const menu = document.querySelector('.header__nav');
    if(menu && menuBtn) {
        menuBtn.addEventListener('click', () => {
            menu.classList.toggle('active');
            menuBtn.classList.toggle('active');
            document.body.classList.toggle('no-scroll');
        });
    }
    const subMenus = document.querySelectorAll('.btn__sub-menu');
    if(subMenus) {
        subMenus.forEach(subMenu => {
            subMenu.addEventListener('click', () => {
                subMenu.classList.toggle('active');
                subMenu.parentNode.parentNode.querySelector('.sub-menu').classList.toggle('active');
            });
        });
    }
});